import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import axios from 'axios';
import HotelCard from './HotelCard';

const HotelList = ({ hotels }) => {
    const [hotelDetails, setHotelDetails] = useState({});
    const [loading, setLoading] = useState(true);
    console.log(hotels);
    useEffect(() => {
        const fetchHotelDetails = async () => {
            if (!hotels?.data?.length) return;

            const token = sessionStorage.getItem("jwtToken");
            if (!token) {
                console.error("JWT Token not found in sessionStorage.");
                return;
            }

            try {
                const requests = hotels.data.map((hotel) =>
                    axios.post(
                        'https://api.ipaisa.co.in/myapp/hotels/details',
                        { Hotelcodes: hotel.HotelCode, Language: "EN" },
                        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
                    )
                );

                const responses = await Promise.all(requests);
                const detailsMap = {};

                responses.forEach(response => {
                    if (response.data?.HotelDetails) {
                        response.data.HotelDetails.forEach(detail => {
                            const baseHotel = hotels.data.find(h => h.HotelCode === detail.HotelCode);
                            if (baseHotel) {
                                detailsMap[detail.HotelCode] = {
                                    ...baseHotel, // Original hotel data
                                    ...detail, // Overwrite with API details
                                };
                            }
                        });
                    }
                });

                setHotelDetails(detailsMap);
                console.log(detailsMap);
                console.log("Merged Hotel Details:", JSON.stringify(detailsMap, null, 2));

            } catch (error) {
                console.error("Error fetching hotel details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchHotelDetails();
    }, [hotels]);
    if (loading) {
        return <Typography variant="h6">Loading hotel details...</Typography>;
    }

    if (!hotels.data || hotels.data.length === 0) {
        return <Typography variant="h6">No hotels found for the selected city.</Typography>;
    }

    return (
        <Grid container direction="row" spacing={2} justifyContent="center">
            {hotels.data.map((hotel, index) => (
                <Grid item xs={12} sm={6} md={8} key={index}>
                    <HotelCard hotel={hotelDetails[hotel.HotelCode] || hotel} />
                </Grid>
            ))}
        </Grid>
    );
};

export default HotelList;
